// extracted by mini-css-extract-plugin
export var arrow = "_cg-2";
export var label = "_cg-1";
export var reminder = "_cg-0";